import styles from '../../../styles/DynamicModal.module.css';

import IconContainer from '../../IconContainer';
import { ReactComponent as XIcon } from '../../../icons/x-close.svg';

const DeleteAC = ({ closeModal, handleChangeIsActive }) => {
    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>Обратите внимание</h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    <p style={{fontSize: '14px'}}>При скрытии Арбитражного суда из системы он не исчезает полностью, а становится недоступным для выбора и добавления в любых разделах системы. В уже созданных делах, где этот суд был указан, он продолжит отображаться</p>
                </div>
                <div className={styles.bottom}>
                    <div></div>
                    <button 
                    type='button' 
                    className='button red' 
                    onClick={() => {
                        handleChangeIsActive();
                        closeModal();
                    }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="trash-alt"><path fill="currentColor" d="M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z"></path></svg>
                        Скрыть
                    </button>
                </div>
            </div>
        </div>
    )
}

export default DeleteAC;